import {
    basePath
} from '../../common/path'

const paths = {
    htGesDashboardSVE: basePath.concat('/ges/dashboard/sve'),
}

export { paths }
